import { types } from "../actions";

const initialState = {
  showInviteUserModal: false,
  billingAccounts: [],
};

export const inviteUserModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_INVITE_USER_MODAL:
      return {
        ...state,
        showInviteUserModal: action.payload,
      };
    case types.SET_BILLING_ACCOUNTS:
      return {
        ...state,
        billingAccounts: action.billingAccounts,
      };
    default:
      return state;
  }
};
